import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import {store} from '@/lib/store.js';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import '@/assets/style/base.scss';
import '@/assets/style/mobile.scss';
import '@/assets/style/pages.scss';

let app = createApp(App);


app.use(router);
app.use(store);
app.component('VueDatePicker', VueDatePicker);
app.mount('#app');
